<template>
    <div>
        <PasoUno
            :pack="pack"
            @zonaSeleccionada="zona_seleccionada = $event"
            v-if="! zona_seleccionada"
        />

        <PasoDos
            v-if="zona_seleccionada"
            :zona="zona_seleccionada"
            :disabled="asientos.length > 0"
            :pack="pack"
            @reset="reset"
            @continuar="pasoDosTerminado"
        />

        <PasoTres
            v-if="asientos.length > 0"
            :pack="pack"
            :asientos="asientos"
            :session_id="session_id"
            :continuarConCompra="continuarConCompra"
            @continuar="pasoTresTerminado"
        />

        <PasoCuatro
            v-if="procesarPago"
            :asientos="asientos"
            :datos_comprador="datos_comprador"
            :formulario="formulario_compra"
            :jet_id="jet_id"
            :session_id="session_id"
        />
    </div>
    
</template>

<script>
    import PasoUno from './pasos/PasoUno.vue';
    import PasoDos from './pasos/PasoDos.vue';
    import PasoTres from './pasos/PasoTres.vue';
    import PasoCuatro from './pasos/PasoCuatro.vue';

    export default {
        props:{
            pack: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                zona_seleccionada: null,
                session_id: null,
                asientos: [],
                formulario_compra: null,
                datos_comprador: null,
                jet_id: null,
                procesarPago: false,
                continuarConCompra: false
            }
        },
        methods: {
            reset() {
                this.zona_seleccionada = null;
                this.datos_compra = null;
            },
            pasoDosTerminado(asientos, session_id) {
                this.session_id = session_id;
                this.asientos = asientos;
            },
            pasoTresTerminado(datos, formulario, jet_id) {
                this.formulario_compra = formulario;
                this.jet_id = jet_id;
                this.datos_comprador = datos;
                this.continuarConCompra = true;
                this.procesarPago = true;
            }
        },
        components: {
            PasoUno, PasoDos, PasoTres, PasoCuatro
        }
    }
</script>